class TablePagination {
  constructor() {
    this.itemsPerPage = 25;
    this.currentPage = 1;
    this.totalItems = 0;
    this.allGroups = [];
    this.visibleGroups = [];

    this.loadMoreBtn = document.querySelector('#table-pagination-load-more');
    this.tableBody = document.querySelector('.table-body');

    this.init();
  }

  init() {
    if (!this.tableBody || !this.loadMoreBtn) return;

    this.initRefresh();

    // Setup event listeners
    this.setupEventListeners();
  }

  initRefresh() {
    const allGroups = this.tableBody?.querySelectorAll('.table-group');

    if (!allGroups || !allGroups.length) {
      return;
    }

    this.allGroups = Array.from(allGroups);
    this.totalItems = this.setTotalItems();

    // Setup initial display
    this.setupInitialDisplay();
  }

  setTotalItems() {
    let total = 0;
    this.allGroups.forEach((group) => {
      const rows = group.querySelectorAll('.table__row');
      total += rows.length + 1; // +1 for the header row
    });

    return total;
  }

  setupInitialDisplay() {
    let totalForOnePage = 0;

    this.allGroups.forEach((group) => {
      const rows = group.querySelectorAll('.table__row');
      totalForOnePage += rows.length + 1; // +1 for the header row

      if (totalForOnePage >= this.itemsPerPage) {
        this.hidePaginationButtons();
      }
    });

    // Show only first 'itemsPerPage' items initially
    this.showItems(0, this.itemsPerPage);

    // Update button states
    this.updateButtonStates();
  }

  setupEventListeners() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => this.loadMore());
    }
  }

  showItems() {
    let total = 0;
    const endIndex = this.currentPage * this.itemsPerPage;
    this.visibleGroups = []; // Reset visible groups

    this.allGroups.forEach((group) => {
      if (total < endIndex) {
        // eslint-disable-next-line no-param-reassign
        group.style.display = '';
        this.visibleGroups.push(group);
        total += group.querySelectorAll('.table__row').length + 1; // +1 for the header row
      } else {
        // eslint-disable-next-line no-param-reassign
        group.style.display = 'none';
      }
    });
  }

  loadMore() {
    this.currentPage++;
    this.showItems();

    this.updateButtonStates();
  }

  updateButtonStates() {
    const visibleCount = this.getVisibleCount();

    // Show/hide Load More button
    if (visibleCount >= this.totalItems) {
      this.loadMoreBtn.style.display = 'none';
    } else {
      this.loadMoreBtn.style.display = 'flex';
    }
  }

  getVisibleCount() {
    let total = 0;
    this.visibleGroups.forEach((group) => {
      total += group.querySelectorAll('.table__row').length + 1; // +1 for the header row
    });
    return total;
  }

  hidePaginationButtons() {
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
  }

  // Method to refresh pagination after filters are applied
  refresh() {
    this.currentPage = 1;
    this.totalItems = 0;
    this.allGroups = [];
    this.visibleGroups = [];

    this.initRefresh();
  }
}

export default TablePagination;
